import { styled } from 'styled-components';

import { cssBreakpoints, spacing } from '#/theme/theme';

export const SearchResultsBodyHolder = styled.main`
  --local-horizontal-padding: ${spacing[30]};

  max-width: calc(933px + var(--local-horizontal-padding) * 2);
  margin-top: 24px;
  margin-left: auto;
  margin-right: auto;
  padding: 0 var(--local-horizontal-padding);

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    padding-bottom: 48px;
  }
`;
